import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar/Navbar";

type BaseContainerProps = {};

const BaseContainer: FC<BaseContainerProps> = () => {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
};

export default BaseContainer;
